import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useState } from "react";

interface RevokeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const RevokeModal = ({ isOpen, onClose, onConfirm }: RevokeModalProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Important</DialogTitle>
        </DialogHeader>
        <div className="text-sm">
          <p>
            Revoking credentials will undeploy all deployed strategies with this
            broker.
          </p>
          <br></br>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            disabled={loading}
            loadingText={loading}
            onClick={async () => {
              setLoading(true);
              await onConfirm();
              onClose();
              setLoading(false);
            }}
          >
            Revoke now
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RevokeModal;
